import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import { Stack } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { IPageHeader } from './@types'

export function Header({ disableBackButton, children, ...props }: IPageHeader) {
  const navigate = useNavigate()

  return (
    <Stack
      direction="row"
      {...props}
      style={{
        ...props.style,
        display: 'flex',
        width: '100%',
        paddingBottom: 18,
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      {!disableBackButton && (
        <ArrowBackIosIcon
          sx={{ fontSize: 30 }}
          onClick={() => {
            navigate(-1)
          }}
        />
      )}
      {children}
    </Stack>
  )
}
